/** @flow */

import type { EmploymentDetailsState } from "./types";

export const initialState: EmploymentDetailsState = {
  requestsInProgress: 0,
  roleSummary: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  changelog: {
    list: {
      content: [],
      pagination: {
        sort: { orders: [] },
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
      totalElements: 0,
    },
  },
  specialContacts: [],
  modals: {
    addPosition: {
      visible: false,
    },
    editPosition: {
      visible: false,
      formData: {},
    },
    deleteSpecialContacts: {
      visible: false,
      selectedSpecialContactId: null,
    },
  },
  schema: {
    employeePosition: {},
  },
};

export default initialState;
